import jquery from 'jquery';
import "@fancyapps/fancybox";
import 'bootstrap/dist/js/bootstrap.bundle';
import 'jquery.animate-number/jquery.animateNumber';


import "./core/plugins/jquery.menu";
import "./core/functions";
import './elements/search';
import './elements/dropdown-menu';

window.jQuery = jquery;
window.$ = jquery;
window.jquery = jquery;


